import React from 'react'
import { Badge, Tag, Space, Typography } from 'antd'

const { Text } = Typography

// Format status with badge
export const getStatusBadge = (status) => {
  return status === 'Completed' ? (
    <Badge status='success' text='Completed' />
  ) : (
    <Badge status='processing' text='Pending' />
  )
}

// Format date and time
export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// Format date only
export const formatDate = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleDateString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
}

// Format patient info with name and ID
export const formatPatientInfo = (name, id) => (
  <Space direction='vertical' size={0}>
    <Text>{name}</Text>
    <Text type='secondary' style={{ fontSize: '12px' }}>
      {id}
    </Text>
  </Space>
)

// Format diagnosis list as tags
export const formatDiagnosis = (diagnoses) => {
  // Add a consistent color mapping for common diagnoses
  const diagnosisColors = {
    Pneumonia: 'geekblue',
    'COPD Exacerbation': 'purple',
    Hypertension: 'red',
    'Diabetes Mellitus': 'orange',
    'Heart Failure': 'volcano',
    'Myocardial Infarction': 'red',
    'Urinary Tract Infection': 'gold',
    Asthma: 'cyan',
    'Acute Renal Failure': 'magenta',
    Dehydration: 'blue',
    'Cesarean Delivery': 'green',
    'Gestational Diabetes': 'orange'
  }

  return (
    <div>
      {diagnoses.map((diagnosis, index) => {
        // Use the color mapping if available, or default to blue
        const color = diagnosisColors[diagnosis] || 'blue'
        return (
          <Tag key={index} color={color} style={{ margin: '4px' }}>
            {diagnosis}
          </Tag>
        )
      })}
    </div>
  )
}
